import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import StatePresenter from '../../../packages/kiti/components/helpers/StatePresenter'
import LazyAction from '../../../packages/kiti/components/helpers/LazyAction'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import { cleanWhenEnabledFilterIsSet } from '../../../modules/_helpers/filterByEnabled'

const Context = React.createContext()
const { Provider } = Context
export const useAssetsState = () => React.useContext(Context) || {}
export const useAssets = () => useAssetsState()?.assets || []

const QUERY = gql`
  query Assets($page: Int, $limit: Int, $search: String, $sort: AssetSort, $filter: AssetFilter) {
    assets(page: $page, limit: $limit, search: $search, sort: $sort, filter: $filter) {
      id
      name
      type {
        id
        name
      }
      place {
        id
        name
      }
    }
  }
`

const AssetsLoader = ({ children, ignoreSegments = false, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...cleanWhenEnabledFilterIsSet({ ...filter }), ignoreSegments }
    },
    client: placesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default AssetsLoader
